import React from 'react';
import logos from '../layout/pageheader.jpeg'

function Contact() {
    return (
        <div>
            <div class="hero-section bg_img style-two" style={{ backgroundImage: `url(${logos})` }}>
                <div class="container">
                    <div class="row">
                        <div class="col-xl-8 col-md-10">
                            <div class="cate-header cl-white">
                                <h1 class="cate-title">Contact our Online Support Desk</h1>
                                <p>Can’t find the answer you’re looking for? Don't worry! Get in touch with the Docs Support
                                    team, we will be glad to assist you.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="contact-form-section padding-bottom pos-rel">
                <div class="container">
                    <div class="contact-wrapper oh mt--160">
                        <div class="contact-header">
                            <h5 class="title">Contact Information</h5>
                            <div class="contact-info-area">
                                <div class="contact-info-item">
                                    <a href="Tel:0123012015200">
                                        <img src="./assets/images/contact/01.png" alt="contact" />
                                        <span>+233545905150 / +233505866057 / +233575908638</span>
                                    </a>
                                </div>
                                <div class="contact-info-item">
                                    <a href="Mailto:support@supporthq.com">
                                        <img src="./assets/images/contact/02.png" alt="contact" />
                                        <span><span class="__cf_email__" data-cfemail="5c2f292c2c332e281c2f292c2c332e28342d723f3331">support@supporthq.com</span></span>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <form class="contact-form row" id="contact_form_submit">
                            <div class="form-group col-md-6">
                                <label for="name">First Name</label>
                                <input type="text" id="name" name="name" />
                            </div>
                            <div class="form-group col-md-6">
                                <label for="lastname">Last Name</label>
                                <input type="text" id="lastname" name="name" />
                            </div>
                            <div class="form-group col-md-6">
                                <label for="phone">Phone Number</label>
                                <input type="text" id="phone" name="phone" />
                            </div>
                            <div class="form-group col-md-6">
                                <label for="email">Email Address</label>
                                <input type="text" id="email" name="email" />
                            </div>
                            <div class="form-group col-md-12">
                                <label for="message">Message</label>
                                <textarea id="message" name="message"></textarea>
                            </div>
                            <div class="form-group col-md-12">
                                <div class="form-submit">
                                    <button type="submit" class="custom-button">Send Email</button>
                                    <p>Need a quick answer? <a href="faq.html">Your answer might be in our FAQs.</a></p>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Contact;
